<template>
    <div
        class="rating-wrapper"
        :style="{ height: height + 'px', '--gap': gap + 'px' }"
    >
        <div class="icon-wrapper" v-for="(icon, index) in icons" :key="index">
            <div
                v-if="icon.type === 'half'"
                class="active-half-icon"
                :style="{
                    width: icon.width + '%',
                }"
            >
                <img
                    :fetchpriority="priority ? 'high' : 'low'"
                    :src="activeIconPath()"
                    :width="removeStr(width, 'px')"
                    :height="removeStr(height, 'px')"
                    alt="rating icon"
                    :style="{
                        'min-width': width,
                    }"
                />
            </div>

            <img
                :fetchpriority="priority ? 'high' : 'low'"
                v-else-if="icon.type === 'full'"
                :src="activeIconPath()"
                :width="removeStr(width, 'px')"
                :height="removeStr(height, 'px')"
                alt="rating icon"
            />

            <img
                :class="icon.type === 'half' ? 'inactive-half-icon' : ''"
                v-if="icon.type !== 'full'"
                :src="inactiveIconPath()"
                :width="removeStr(width, 'px')"
                :height="removeStr(height, 'px')"
                alt="rating icon"
            />
        </div>
    </div>
</template>

<script>
import { helper } from '@/mixins';

export const ratingIcons = [
    'star',
    'heart',
    'spoon',
    'fork',
    'fork-knife',
    'tick',
];
export default {
    name: 'Rating',
    mixins: [helper],
    data: () => {
        return {
            icons: [],
        };
    },
    props: {
        height: {
            type: String,
            default: '20px',
        },
        width: {
            type: String,
            default: '20px',
        },
        maxRating: {
            type: Number,
            default: 5,
        },
        rating: {
            type: [Number, String],
            default: 0,
        },
        activeColor: {
            type: String,
            default: '#e4720c',
        },
        inactiveColor: {
            type: String,
            default: 'transparent',
        },
        activeIcon: {
            type: String,
            default: 'star',
        },
        inactiveIcon: {
            type: String,
        },
        gap: {
            type: Number,
            default: 1,
        },
        priority: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        activeIconPath() {
            let imageUrl =
                this.$globalConstants.imageUrl + '/img/icons/rating-icons/';
            return `${imageUrl}${this.activeIcon}.svg?d=${this.removeStr(
                this.width,
                'px'
            )}x${this.removeStr(this.height, 'px')}&color=${this.removeStr(
                this.activeColor,
                '#'
            )}`;
        },
        inactiveIconPath() {
            let imageUrl =
                this.$globalConstants.imageUrl + '/img/icons/rating-icons/';

            if (this.inactiveIcon) {
                return `${imageUrl}${this.inactiveIcon}.svg?d=${this.removeStr(
                    this.width,
                    'px'
                )}x${this.removeStr(this.height, 'px')}&color=${this.removeStr(
                    this.inactiveColor,
                    '#'
                )}`;
            } else {
                return this.activeIconPath();
            }
        },
        removeStr(str, val) {
            return str.replace(val, '');
        },
        getRatingIcons() {
            let icons = [];
            let i = -1;
            let type;
            let width;
            while (++i < this.maxRating) {
                width = 100;
                switch (true) {
                    case this.rating / 2 - i >= 1:
                        type = 'full';
                        break;
                    case this.rating / 2 - i <= 0:
                        type = 'empty';
                        break;
                    default:
                        type = 'half';
                        width = Math.round((this.rating / 2 - i) * 100);
                        break;
                }
                icons.push({ type, width });
            }

            return icons;
        },
    },
    created() {
        this.icons = this.getRatingIcons();
    },
};
</script>

<style scoped lang="scss">
@import '@/sass/flex-gap';

.rating-wrapper {
    display: flex;
    justify-content: center;
    @include customGap(--gap, 0);
}

.icon-wrapper {
    position: relative;
    display: flex;
}

.active-half-icon {
    display: flex;
    z-index: 2;
    position: relative;
    overflow: hidden;
}

.inactive-half-icon {
    z-index: 1;
    position: absolute;
    top: 0;
}
</style>
